var LinkVariant;
(function (LinkVariant) {
    LinkVariant["primary"] = "primary";
    LinkVariant["secondary"] = "secondary";
    LinkVariant["secondaryInvert"] = "secondaryInvert";
})(LinkVariant || (LinkVariant = {}));

export { LinkVariant };
